require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./package-unpublished-glennsl-bs-jsx-rewriter.json") })
        }
      }, "path---package-unpublished-glennsl-bs-jsx-rewriter");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---package-unpublished-glennsl-bs-jsx-rewriter!./.cache/json/package-unpublished-glennsl-bs-jsx-rewriter.json
// module id = 939
// module chunks = 231608221292675